export enum ChequeStatus {
  ISSUED = 1,
  REALIZED = 2,
  RETURNED = 3,
  CANCELLED = 4,
}

export const ChequeStatusLabels: Record<number, string> = {
  [ChequeStatus.ISSUED]: 'Issued',
  [ChequeStatus.REALIZED]: 'Realized',
  [ChequeStatus.RETURNED]: 'Returned',
  [ChequeStatus.CANCELLED]: 'Cancelled',
};

export const getChequeStatusLabel = (status: number): string => {
  return ChequeStatusLabels[status] || 'Unknown';
};
